// React
import React from "react";
import PropTypes from "prop-types";
// Styles
import styles from "./EmptyTable.css";

const EmptyTable = ({ colspan, isLoading, noData, emptyMessage }) => {
  if (!isLoading && !noData) {
    return null;
  }

  return (
    <tr role="row" style={styles.container}>
      <td colSpan={colspan}>
        {(() => {
          if (isLoading) {
            return <i className="fa fa-refresh fa-spin" />;
          }
          if (!isLoading && noData) {
            return emptyMessage;
          }
        })()}
      </td>
    </tr>
  );
};

EmptyTable.propTypes = {
  colspan: PropTypes.number,
  emptyMessage: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  noData: PropTypes.bool.isRequired
};

export default EmptyTable;
